module.exports = __webpack_public_path__ + "static/media/logos.e6e1670f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos.png
// module id = 368
// module chunks = 3